import './styles/appbar.css';
import { useGameStore } from '../../store/gameStore';
import { useShallow } from 'zustand/shallow';
import IconBtn from '../subcomponents/IconBtn';
import TitleLogo from './TitleLogo';
import { menuAnimationDelay } from '../utils/animationHelper';
import { useState } from 'react';
import HowToPlayDialog from './dialogs/HowToPlayDialog';

function Appbar() {
  // Subscribe to game store
  const { setGameActive } = useGameStore(
    useShallow((state) => ({
      setGameActive: state.setGameActive,
    }))
  );

  const handleLeaveGame = () => {
    const gamePageElement = document.querySelector('.game-container');
    gamePageElement?.classList.remove('fade-in-right');
    gamePageElement?.classList.add('fade-out-right');
    setTimeout(() => {
      setGameActive(false);
    }, menuAnimationDelay);
  };

  const [showHowToPlay, setShowHowToPlay] = useState<boolean>(false);

  return (
    <div className="appbar-container text-[var(--text-primary)]">
      <IconBtn icon="ChevronLeft" largeStrokeSize secondary onClick={handleLeaveGame} />
      <TitleLogo secondary />
      <IconBtn
        icon="CircleHelp"
        secondary
        mediumStrokeSize
        onClick={() => setShowHowToPlay(true)}
      />
      <HowToPlayDialog
        open={showHowToPlay}
        onClose={() => {
          setShowHowToPlay(false);
        }}
      />
    </div>
  );
}

export default Appbar;
